/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AlertActionRequest {
    getFixupPrototypeFunction() { return AlertActionRequest.fixupPrototype; }

    static newInstance(model: Partial<AlertActionRequest>): AlertActionRequest {
        let obj = Object.assign(new AlertActionRequest(), model);
        AlertActionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AlertActionRequest>): AlertActionRequest {
        if (!model) return null;
        return AlertActionRequest.newInstance(<AlertActionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AlertActionRequest) {
        if (!obj) return;

        models.AlertActionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AlertActionRequest): boolean {
        Object.setPrototypeOf(obj, AlertActionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Inventory Ids of the Alert Rules
     */
    alert_ids: Array<string>;

}
